module.exports = __webpack_public_path__ + "static/media/full_logo.08cf17e1.svg";